import type { MotionProps, Variant } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const visible = buildVisibleVariant();
const hidden = buildHiddenVariant();

/*
 * Word Animations
 */
export interface CustomWordVisibleVariantProperties {
  index: number;
  delay?: number;
  staggerChildren?: number;
}

function customWordVisible({
  index = 0,
  delay = 0.2,
  staggerChildren = 0.04,
}: CustomWordVisibleVariantProperties): Variant {
  return {
    ...visible,
    transition: {
      delayChildren: index * delay,
      staggerChildren,
    },
  };
}

export function buildWordMotionProperties(
  custom: CustomWordVisibleVariantProperties,
): MotionProps {
  return {
    animate: 'visible',
    custom,
    initial: 'hidden',
    variants: {
      hidden,
      visible: customWordVisible as Variant,
    },
    viewport: { once: true },
    whileInView: 'visible',
  };
}

/*
 * Character Animations
 */
export type Axis = 'x' | 'y';

export interface CustomCharHiddenVariantProperties {
  axis?: Axis;
  value?: number;
}

function customCharHidden({
  axis = 'y',
  value = -30,
}: CustomCharHiddenVariantProperties): Variant {
  return {
    ...hidden,
    [axis]: value,
  };
}

export function buildCharMotionProperties(
  custom: CustomCharHiddenVariantProperties,
): MotionProps {
  return {
    custom,
    variants: {
      hidden: customCharHidden as Variant,
      visible: buildVisibleVariant({
        transition: {
          duration: 0.4,
        },
      }),
    },
  };
}
